module.exports = function() {
  return new Worker(__webpack_public_path__ + "ed69ce7a022d8177208c.worker.js");
};